











import { Component } from 'vue-property-decorator'
import DialogBase from '@/classes/Dialog'
import FormBase from '@/classes/Form/FormBase'
import Field, { FieldSizes } from '@/classes/Form/Field'
import { FieldTypes } from '@/components/Form/FieldTypes'
import Form from '@/components/Form/Form.vue'
import { HttpMethod } from '@/helpers/requests'
import { Actions } from '@/store/global/actions'
import RecommendationFieldModel, {
  RecommendationFieldAttribute,
} from '@/modules/recommendation/recommendation-field.model'

@Component({
  components: {
    Form,
  },
})
export default class EditDialog extends DialogBase {
  form: FormBase = new FormBase()
    .setUuid(this.meta.entry.uuid)
    .setEndpoint('referrals')
    .setModel(RecommendationFieldModel)
    .setEntry(this.meta.entry)
    .setMethod(HttpMethod.PUT)
    .setFields([
      new Field().setKey(RecommendationFieldAttribute.title).setTitle('Pavadinimas').setDense(true),
      new Field()
        .setType(FieldTypes.checkbox)
        .setKey(RecommendationFieldAttribute.is_business)
        .setDense(true)
        .setTitle('Verslui')
        .setSize(FieldSizes.half),
      new Field()
        .setType(FieldTypes.checkbox)
        .setKey(RecommendationFieldAttribute.is_individual)
        .setDense(true)
        .setTitle('Individualiems')
        .setSize(FieldSizes.half),
      new Field()
        .setType(FieldTypes.checkbox)
        .setKey(RecommendationFieldAttribute.is_active)
        .setDense(true)
        .setTitle('Aktyvus'),
    ])
    .setOnSuccess(this.onSuccess)

  onSuccess(data: any, entry: RecommendationFieldModel): void {
    this.$store.dispatch(Actions.showSnackbar, {
      type: 'success',
      message: 'Rekomendacija buvo sėkmingai paredaguota',
    })
    this.meta.onSuccess(entry)
    this.closeDialog()
  }
}
